export default __webpack_public_path__ + "static/media/Habitat.ee1cb541.svg";